exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fast[data-v-61c76458]{animation-duration:.25s}.keyboard-wrapper[data-v-61c76458]{position:fixed;z-index:10000;bottom:10px;left:0;width:100%;display:flex;justify-content:center;pointer-events:auto}.inner-wrapper[data-v-61c76458]{width:100%;max-width:600px;position:relative}@keyframes wrap-data-v-61c76458{0%{bottom:-100%}to{bottom:10px}}.simple-keyboard[data-v-61c76458]{max-width:600px;pointer-events:auto}.simple-keyboard.hg-layout-default .hg-button.expend-space[data-v-61c76458],.simple-keyboard.hg-layout-shift .hg-button.expend-space[data-v-61c76458]{flex-grow:7}.simple-keyboard.hg-theme-default.myTheme[data-v-61c76458]{background-color:#d3d3d3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61c76458","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/keyboard/CustomKeyboard.vue
// module id = 440
// module chunks = 187